import { css, Theme } from "@emotion/react";

export const loader = (theme: Theme) =>
    css({
        paddingLeft: 40,
        marginLeft: -40,
        position: "absolute",
        zIndex: 100,
        height: "100%",
        width: "100%",

        "::after": {
            background: theme.candy.keyPalette.primaryBackgroundColor,
            content: '" "',
            opacity: 0.8,
            zIndex: 500,
            bottom: 0,
            left: 0,
            position: "absolute",
            right: 0,
            top: 0,
        },
    });

export const loaderText = (theme: Theme) =>
    css({
        color: theme.candy.typography.primary.color,
        zIndex: 501,
        position: "absolute",
        top: "5%",
        left: "40%",
        textAlign: "center",
    });
